import React from 'react';
import styled from '@emotion/styled';
import { height, width } from 'styled-system';
import type { HeightProps, WidthProps } from 'styled-system';

import arrow from '../../../assets/icons/arrow-left.svg';

interface ArrowIconProps {
  arrowSize?: number | string;
  src?: string;
  alt?: string;
}

const StyledArrowIcon = styled.img<WidthProps & HeightProps>`
  ${width};
  ${height};
`;

const ArrowIcon = ({ alt, src = arrow, arrowSize = '22px' }: ArrowIconProps) => {
  return <StyledArrowIcon src={src} alt={alt} width={arrowSize} height={arrowSize} />;
};

export default ArrowIcon;
